<template>
  <div class="landing">
    <div class="bg">
      <div class="container mt">
        <div class="row">
          <div class="col s12 m5">
            <div class="card shadow" style="margin-top: 100px">
              <div class="heading">Let's link</div>
              <div class="row">
                <form class="col s12" @submit.prevent="sendEmail">
                  <div class="row">
                    <div class="form__group field">
                      <input
                        type="text"
                        class="form__field"
                        placeholder="Name"
                        name="name"
                        id="name"
                        required
                        v-model="name"
                      />
                      <label for="name" class="form__label">Name</label>
                    </div>
                    <div class="form__group field">
                      <input
                        type="email"
                        class="form__field"
                        placeholder="Email"
                        id="Email"
                        required
                        v-model="email"
                      />
                      <label for="Email" class="form__label">Email</label>
                    </div>
                    <div class="form__group field">
                      <textarea
                        class="form__field"
                        placeholder="Message"
                        name="Message"
                        id="Message"
                        required
                        v-model="message"
                        style="resize: none; height: 105px"
                      ></textarea>
                      <label for="Message" class="form__label">Message</label>
                    </div>

                    <input
                      v-if="!success"
                      type="submit"
                      class="btn form"
                      value="Submit"
                      name=""
                    />
                    <input
                      v-else
                      class="btn form"
                      type="submit"
                      disabled
                      value="successful"
                      name=""
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col s12 m7"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
import { ref } from "@vue/reactivity";
export default {
  setup() {
    emailjs.init("user_757pXJlodVbY0yXVNxDPH");

    const name = ref("");
    const email = ref("");
    const message = ref("");
    const success = ref(false);
    const sendEmail = () =>
      emailjs
        .send("service_qq4rfe2", "template_34phk85", {
          name: name.value,
          email: email.value,
          message: message.value,
        })
        .then(
          (result) => {
            console.log("SUCCESS!", result.text);
            name.value = "";
            email.value = "";
            message.value = "";
            success.value = true;

            setTimeout(() => {
              success.value = false;
            }, 3000);
          },
          (error) => {
            console.log("FAILED...", error.text);
          }
        );
    return {
      sendEmail,
      name,
      email,
      message,
      success,
    };
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background-color: black;
  bottom: 0;
}
.bg {
  background-image: url("../../assets/vectors/link.svg");
  background-size: 47%;
  background-repeat: no-repeat;
  background-position: right 150px;
  height: 700px;
  padding-top: 20px;
}
.mt-5 {
  margin-top: -100px !important;
}
.landing:after {
  position: absolute;
  top: 0;
  margin-top: -150px;
  content: "";
  right: 0;
  left: 0;
  z-index: -1;
  bottom: 0;
  height: 80vh;
  background-color: #765cd1;
  transform: skewY(-5deg);
}
.shadow {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.22);
}
.socials {
  padding: 2px;
  padding-top: 7px;
}
.icon {
  padding: 10px;
}
.card {
  background-color: #fffefe;
  padding-right: 40px;
  padding-left: 40px;
}

.heading {
  font-size: 36px;
  text-align: center;
  padding: 10px;
  font-weight: 600;
}

@media only screen and (max-width: 601px) {
  .landing:after {
    position: absolute;
    top: 0;
    margin-top: -8px;
    content: "";
    right: 0;
    left: 0;
    z-index: -1;
    bottom: 0;
    height: 50vh;
    background-color: #765cd1;
    transform: skewY(-15deg);
  }
  .bg {
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: left 150px;
    height: 100vh;
    padding-top: 20px;
  }
  .footer {
    margin-bottom: 50px;
  }
  .links {
    padding: 3px;
  }
  .card {
    background-color: white;
    opacity: 0.83;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.22);
    padding-right: 40px;
    padding-left: 40px;
  }
}
//form
$primary: #11998e;
$secondary: #38ef7d;
$white: #fff;
$gray: #9b9b9b;
.form__group {
  position: relative;
  padding: 12px 0 0;
  margin-top: 4px;
  width: 100%;
}

.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid black !important;
  outline: 0;
  font-size: 14px;
  color: black;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;

  &::placeholder {
    color: transparent;
  }

  &:placeholder-shown ~ .form__label {
    font-size: 14px;
    cursor: text;
    top: 20px;
  }
}
.form {
  background-color: #765cd1;
}

.form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 1rem;
  color: black !important;
}

.form__field:focus {
  ~ .form__label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #765cd1 !important;
    font-weight: 700;
  }
  padding-bottom: 6px;
  font-weight: 700;
  border-width: 3px;
  border-image: linear-gradient(to right, #765cd1, #765cd1);
  border-image-slice: 1;
}
/* reset input */
.form__field {
  &:required,
  &:invalid {
    box-shadow: none;
  }
}
</style>
